/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MainCircuitBreakerEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const MainCircuitBreakerEnum = {
    NUMBER_1: 1 as MainCircuitBreakerEnum,
    NUMBER_2: 2 as MainCircuitBreakerEnum,
    NUMBER_3: 3 as MainCircuitBreakerEnum,
    NUMBER_4: 4 as MainCircuitBreakerEnum,
    NUMBER_5: 5 as MainCircuitBreakerEnum,
    NUMBER_6: 6 as MainCircuitBreakerEnum,
    NUMBER_7: 7 as MainCircuitBreakerEnum,
    NUMBER_8: 8 as MainCircuitBreakerEnum
};

